<template>
    <div class="category-filter"  v-click-outside="() => {showCategories = false}"> 
        <div class="select-categories" @click="showCategories = !showCategories">
            {{label}} <i class="icon-arrow-collapse"></i>
        </div>
        <!-- <div class="select-categories" @click="showCategories = !showCategories">
            #
        </div> -->
        <div class="categories-list" v-if="showCategories">
            <new-category @addNewCategory="createNewCategory"></new-category>
            <category 
                v-for="(category, index) in unselectedCategories" 
                :key="index" 
                :label="category.label"
                :selected="category.selected"
                :disabled="false"
                @click="toggleCategory(index)">
            </category>

        </div>
    </div>
</template>

<script>
import Category from './Category'
import NewCategory from './NewCategory.vue'

import api from '@/api'

export default {
    components: {
        Category,
        NewCategory
    },
    props: {
        categories: {
            type: Array
        },
        label: {
            type: String
        }
    },
    computed: {
        unselectedCategories: function() {
            return this.categories && this.categories.filter(category => !category.selected)
        },
        userId() {
            return this.$store.state.user.id;
        },
    },
    data() {
        return {
            showCategories: false
        }
    },
    methods: {
        createNewCategory: async function(label) {
            if(!label || label === "" ) return;
            const result = await api.createNewCategory(label, this.userId);
            this.$emit('newCategoryAdded', result.data.insert_categories_one);
        },
        toggleCategory(selectedIndex) {
            // this.categories[selectedIndex].selected = !this.categories[selectedIndex].selected;
            // this.categories = JSON.parse(JSON.stringify(this.categories));
            this.$emit('selectedCategory', this.unselectedCategories[selectedIndex]);
            
        },
    }
}
</script>

<style scoped>
.category-filter {
}
.category-filter .select-categories {
    background: #e8e8e8;
    display: inline-block;
    padding: 6px 8px;
    font-weight: 700;
    color: #565656;
    border-radius: 4px;
    margin-right: 8px;
}
.category-filter .select-categories i {
    font-size: 16px;
    vertical-align: middle;
}
.category-filter > * {
    display: inline-block;
}
.category-filter .selected-categories {
    display: inline;
}

.category-filter .selected-categories .selected-category,
.category-filter .categories-list .category.selected {
    display: inline-block;
    color: #5A4BB0;
    padding: 6px 8px;
    border-radius: 4px;
    margin-right: 8px;
    background-color: #eceeff;
    margin-bottom: 8px;
}
.category-filter .categories-list {
    display: block;
    position: absolute;
    z-index: 20;
    background: white;
    padding: 12px 12px 4px 12px;
    margin-top: 8px;
    box-shadow: 0px 0px 10px rgb(0 0 0 / 15%);
    border: 1px solid #D9D5D5;
    border-radius: 4px;
    max-width: 400px;
    margin-right: 20px;
}

.category-filter .categories-list .category {
    display: inline-block;
    color: #484848;
    padding: 6px 8px;
    border-radius: 4px;
    margin-right: 8px;
    background-color: #f1f1f1;
    margin-bottom: 8px;
}
</style>